import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";

import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  componentKey,
  setCloseInventoryDialog,
  setCloseSendInventoryDialog,
  setInventoryList,
} from "./InventorySlice";
import InventoryService from "../../services/InventoryService";

export const {
  getInventoryList,
  addInventoryList,
  updateInventoryList,
  deleteInventory,
  sendInventoryToFacility,
} = {
  sendInventoryToFacility: (payload) => {
    return {
      type: "INVENTORY/SEND_TO_FACILITY",
      payload,
    };
  },
  getInventoryList: (payload) => {
    return {
      type: "INVENTORY/GET_INVENTORY_LIST",
      payload,
    };
  },
  addInventoryList: (payload) => {
    return {
      type: "INVENTORY/POST_INVENTORY_LIST",
      payload,
    };
  },
  updateInventoryList: (payload) => {
    return {
      type: "INVENTORY/PATCH_INVENTORY_LIST",
      payload,
    };
  },
  deleteInventory: (payload) => {
    return {
      type: "INVENTORY/DELETE_INVENTORY",
      payload,
    };
  },
};

// GET INVENTORY API CALL FUNCTION
function* getInventoryListAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield InventoryService.getInventoryList(action?.payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setInventoryList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setInventoryList({}));

    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// ADD INVENTORY API CALL FUNCTION
function* addInventoryListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield InventoryService.addInventoryList(action?.payload);
    const { status } = response;
    if (status) {
      const { data, message } = response;
      yield put(setCloseInventoryDialog(true));
      eventEHRCustomToastMessage({
        title: `${response?.data?.message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseInventoryDialog(false));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// ADD INVENTORY API CALL FUNCTION
function* updateInventoryListAsync(action) {
  const { apiPayload, id } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield InventoryService.updateInventoryList(id, apiPayload);
    const { status } = response;
    console.log("response:", response);

    if (status) {
      const { data, message } = response;
      yield put(setCloseInventoryDialog(true));
      eventEHRCustomToastMessage({
        title: `${response?.data?.message}`,
        status: "success",
      });
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseInventoryDialog(false));

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE INVENTORY ASYNC

function* deleteInventoryAsync(action) {
  const { inventoryId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield InventoryService.deleteInventory(inventoryId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setCloseInventoryDialog(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setCloseInventoryDialog(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// SEND MAIN INVENTORY TO A FACILITY
function* sendInventoryToFacilityAsync(action) {
  try {
    yield put(showLoader());
    const response = yield InventoryService.sendInventoryToFacility(
      action?.payload
    );
    const { status } = response;
    if (status) {
      eventEHRCustomToastMessage({
        title: `${response?.data?.message}`,
        status: "success",
      });
      yield put(setCloseSendInventoryDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseSendInventoryDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([takeLatest(getInventoryList().type, getInventoryListAsync)]);
  yield all([takeLatest(addInventoryList().type, addInventoryListAsync)]);
  yield all([takeLatest(updateInventoryList().type, updateInventoryListAsync)]);
  yield all([takeLatest(deleteInventory().type, deleteInventoryAsync)]);
  yield all([
    takeLatest(
      sendInventoryToFacility().type,
      sendInventoryToFacilityAsync
    ),
  ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
